import { LakeExportStatus, LakeFileList, LakeRunList, type LakeFileQuery } from '@regigov/contracts';
import { api } from './client';

export const lakeApi = {
  status: () => api('/lake/status', LakeExportStatus),
  runs: () => api('/lake/runs', LakeRunList),
  files: (query: Partial<LakeFileQuery> = {}) => {
    const params = new URLSearchParams();
    if (query.entityType) params.set('entityType', query.entityType);
    if (query.limit) params.set('limit', String(query.limit));
    const s = params.toString();
    return api(`/lake/files${s ? `?${s}` : ''}`, LakeFileList);
  },
};
